<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="description" class="row-content row-content_text">
      <span
        class="row-content--main"
        v-html="description"
        v-line-clamp="4"
      />
    </li>

    <partial-owners v-if="!isEmpty(inventors)"
      :owners="sortOrder(inventors)"
      :highlights="highlightInventors"
      :highlightKeys="['inventors.name.normalized', 'inventors.initial_name.normalized']"
      :renderWithLinkTo="false"
      :isText="true"
      :text="'Inventors: '"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-owners>

    <partial-organisations v-if="!isEmpty(applicants)"
      :organisations="sortOrder(applicants)"
      :highlights="highlightApplicants"
      :highlightKeys="['applicants.full_name.normalized', 'applicants.initial_name.normalized']"
      :isText="true"
      :text="'Applicants'"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-organisations>

    <partial-organisations v-if="isEmpty(applicants) && !isEmpty(assignees)"
      :organisations="sortOrder(assignees)"
      :highlights="highlightAssignees"
      :highlightKeys="['assignees.full_name.normalized', 'assignees.initial_name.normalized']"
      :isText="true"
      :text="'Assignees'"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-organisations>

    <li v-if="!isEmpty(ipcCode)" class="row-content row-content_text mt-2">
      <span class="row-content--main">
        <span class="t-500">IPC:</span> <span v-html="ipcCode"></span>
      </span>
    </li>

    <li v-if="data.priority_date" class="row-content row-content_text mt-2">
      <span class="row-content--main">
        <span class="t-500">Priority Date:</span> {{ data.priority_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>

    <li v-if="data.application_date" class="row-content row-content_text" :class="{ 'mt-2': isEmpty(data.priority_date) }">
      <span class="row-content--main">
        <span class="t-500">Application Date:</span> {{ data.application_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>

    <li v-if="data.publication_date" class="row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500">Publication Date:</span> {{ data.publication_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>

    <li v-if="data.granted_date" class="row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500">Granted Date:</span> {{ data.granted_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/patent'

import Matches from '@/components/search/results/partials/Matches'
import PartialOwners from '@/components/search/results/partials/Owners'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'patentResultPopover',
  mixins: [processing],
  components: {
    Matches,
    PartialOwners,
    PartialOrganisations
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      this.description ||
      !this.isEmpty(this.inventors) || !this.isEmpty(this.applicants) || !this.isEmpty(this.assignees) ||
      !this.isEmpty(this.ipcCode) ||
      this.data.priority_date ||
      this.data.application_date ||
      this.data.publication_date ||
      this.data.granted_date
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
